import DatePicker, { registerLocale } from "react-datepicker";
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";
import { ja, enGB } from 'date-fns/locale';

registerLocale('ja', ja)
registerLocale('en', enGB)

export const DatePickerComponent = (props: any) => {
  const { t } = useTranslation();
  const {reportDate, setReportDate, Today, minDate, locale} = props;
  const selectedLocale = locale === 'en' ? enGB : ja;
  return (
    <DatePicker
      className="w-[100px] outline outline-1 outline-gray-400 rounded-sm p-2"
      dateFormat="yyyy/MM/dd"
      locale={selectedLocale}
      renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
        <div className="flex justify-between items-center py-0 px-[15px] font-bold">
          <button className="datepicker__button" onClick={decreaseMonth}>
            {"<"}
          </button>
          <div className="flex justify-center items-center">
            <div className="mr-[7px]">{dayjs(date).year()}{t("common.datePickerYear")}</div>
            <div>{dayjs(date).month() + 1}{t("common.datePickerMonth")}</div>
          </div>
          <button className="font-[#757575]" onClick={increaseMonth}>
            {">"}
          </button>
        </div>
      )}
      selected={reportDate}
      placeholderText={t("common.selectDate")}
      onChange={(selectedDate) => {
        setReportDate(selectedDate || Today);
      }}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      minDate={minDate}
    />
  );
};
